module.exports = __webpack_public_path__ + "static/media/recykal-epr-big-image.b6955540.png";